import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as Constants from '@shared/_constants';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css'],
})
export class DialogComponent {
  public title = 'Confirmation Dialog';
  public message = 'Confirmation Message';
  public yesButtonText = 'Yes';
  public noButtonText = 'No';
  public okButtonText = 'OK';
  public showYesNo = false;
  public showOK = false;
  public dialogClass = '';

  constructor(private activeModal: NgbActiveModal) {}

  okClick() {
    this.activeModal.close(Constants.AcknowledgeResult.ok);
  }
  noClick() {
    this.activeModal.close(Constants.ConfirmationResult.no);
  }

  yesClick() {
    this.activeModal.close(Constants.ConfirmationResult.yes);
  }
}
